import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueI18n from 'vue-i18n'
import router from './router'
import store from './store'
import messages from './i18n'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

// Calendar
import VCalendar from 'v-calendar';

// font awesome
import {library} from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { dom } from '@fortawesome/fontawesome-svg-core'
import { performLogoutWithoutRedirect } from '@/auth/logout'
dom.watch()
Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  datePickerTintColor: '#F00',
  datePickerShowDayPopover: false
});

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// translate 
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages
});

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// Auto-logout when returning to tab with expired token
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    try {
      const userData = store.state.app.userData
      if (userData) {
        const now = Math.floor(Date.now() / 1000)
        if (userData.expires > 0 && userData.expires < now) {
          performLogoutWithoutRedirect(store)
        }
      }
    } catch (e) {
      console.warn('Token expiry check failed:', e)
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  created() {
    this.$store.commit('app/SET_STORE_READY', true)
  },
  render: h => h(App),
}).$mount('#app')
